import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getCurrentUser } from "@/lib/auth";
import { getCryptoPrices, CryptoPrice } from "@/lib/crypto";
import { supabase } from "@/lib/supabase";
import { Header } from "@/components/dashboard/Header";
import { WalletCard } from "@/components/dashboard/WalletCard";
import { MarketTable } from "@/components/dashboard/MarketTable";
import { Skeleton } from "@/components/ui/skeleton";
import { toast } from "sonner";

export default function Dashboard() {
  const [user, setUser] = useState<any>(null);
  const [cryptos, setCryptos] = useState<CryptoPrice[]>([]);
  const [wallets, setWallets] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const initDashboard = async () => {
      // Check authentication
      const { user: authUser } = await getCurrentUser();
      if (!authUser) {
        navigate("/auth");
        return;
      }

      setUser(authUser);

      // Fetch crypto prices
      const prices = await getCryptoPrices();
      setCryptos(prices);

      // Fetch user wallets
      const { data: walletData, error } = await supabase
        .from("wallets")
        .select("*")
        .eq("user_id", authUser.id);

      if (error) {
        toast.error("Errore nel caricamento del portafoglio");
        console.error(error);
      } else {
        setWallets(walletData || []);
      }

      setLoading(false);
    };

    initDashboard();
  }, [navigate]);

  if (loading) {
    return (
      <div>
        <Header userEmail={user?.email} />
        <div className="max-w-7xl mx-auto p-4">
          <Skeleton className="h-64 mb-6" />
          <Skeleton className="h-64" />
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-900">
      <Header userEmail={user?.email} />

      <main className="max-w-7xl mx-auto p-4">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
          <div className="lg:col-span-2">
            <h2 className="text-2xl font-bold mb-4">Mercati</h2>
            <div className="bg-slate-800 rounded-lg overflow-hidden">
              <MarketTable cryptos={cryptos} />
            </div>
          </div>
          <WalletCard wallets={wallets} />
        </div>
      </main>
    </div>
  );
}
